import { currencySymbols } from './currencySymbols'

export function formatCurrency (value, currency = null) {
  if (value === null || value === undefined || value === '-' || value === '') return '-'
  const number = Number(value)
  if (isNaN(number)) return value

  const formatted = number.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })

  if (currency) {
    const symbol = currencySymbols[currency] || currency
    return `${symbol} ${formatted}`
  }

  return formatted
}
